/**
 * Holds reference to constants
 * or strings throughout the content
 */
export default {
  eventKeys: {
    DISPOSE_ANY_CARD_OVERLAYS: "cmedOptionsGrid:cards:overlays:dispose",
  },
  socketKeys: {
    CMED_UNDERLYING_SUCCESS: "cmedOptionsGrid:underlying:success",
    CMED_EXPIRY_SUCCESS: "cmedOptionsGrid:expiry:success",
    CMED_FIND_OPTIONS_SUCCESS: "cmedOptionsGrid:findoptions:success",
    CMED_OPTIONS_ERROR: "cmedOptionsGrid:error",
    CMED_LADDER_SUBSCRIPTION_ERROR: "cmedOptionsGrid:ladder:error",
    CMED_ADD_CONTRACTS: "cmedOptionsGrid:addContracts:success",
    CMED_ADD_CONTRACTS_LADDER: "cmedOptionsGrid:addContractsLadder:success",
    CMED_OPTIONS_GRID_ORDER_CRITERIA:
      "cmedOptionsGrid:orderEntryCriteria:success",
    CMED_OPTIONS_ITEM_PRICES: "cmedOptionsGrid:orderItemPrices:success",
    CMED_ORDER_ENTRY: "cmedOptionsGrid:orderEntry:success",
    CMED_ORDER_AMENDMENT: "cmedOptionsGrid:orderAmendment:success",
    CMED_ORDER_ENTRY_ERROR: "cmedOptionsGrid:orderEntry:error",
    CMED_ORDER_AMENDMENT_ERROR: "cmedOptionsGrid:orderAmendment:error",
    CMED_ORDER_AGGRESSION: "cmedOptionsGrid:orderAggression:success",
    CMED_ORDER_AGGRESSION_ERROR: "cmedOptionsGrid:orderAggression:error",
    CMED_SUPPLEMENTAL_DEPTH: "cmedOptionsGrid:supplementalDepth:success",
    CMED_RESTART_OPTIONS_GRID: "cmedOptionsGrid:restart:success",
  },
  stompSubscriptionKeys: {},
  connectionKeys: {},
  socket: {
    actions: {
      CMED_OPTIONSGRID_EXPIRY: "cmed/optionsgrid/expiry",
      CMED_OPTIONSGRID_OPTION_GRID_EXPIRY:
        "cmed/optionsgrid/cmedOptionsGridExpiry",
      CMED_UNDERLYING: "cmed/underlying",
      CMED_ORDERS_SUBSCRIBE: "cmed/orders/subscribe",
      CMED_ORDERS_UNSUBSCRIBE: "cmed/orders/unsubscribe",
      CMED_OPTIONSGRID_FIND_OPTIONS: "cmed/optionsgrid/findOptions",
      CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER:
        "cmed/optionsgrid/subscribeStrikeLadder",
      CMED_OPTIONSGRID_UNSUBSCRIBE_STRIKELADDER:
        "cmed/optionsgrid/unsubscribeStrikeLadder",
      CMED_REMOVE_CONTRACTS: "cmed/removeContractFromGrid",
      CMED_ORDER_ENTRY: "cmed/order/entry",
      CMED_ORDER_AMENDMENT: "cmed/order/amend",
      CMED_ORDER_AGGRESSSION: "cmed/order/aggression",
      CMED_ITEM_PRICES: "cmed/item/prices",
      CMED_ORDER_CRITERIA: "cmed/order/criteria",
      CMED_ADD_CONTRACTS: "cmed/addContractToGrid",
      CMED_SUBSCRIBE_STRIKE_LADDER_DEPTH:
        "cmed/optionsgrid/subscribeStrikeLadderDepth",
      CMED_UNSUBSCRIBE_STRIKE_LADDER_DEPTH:
        "cmed/optionsgrid/unsubscribeStrikeLadderDepth",
    },
    channels: {
      TRADING: "/app/trading",
    },
  },
  cache: {
    underlyingFutures: null,
    expiry: null,
  },
  utility: {
    onlyNumericalRegex:
      /(^-?$)|(^-?\d+([0-9])*$)|(^-?\d+([0-9])*([\\.])?(\d{0,9})$)/,
    priceRegex:
      /(^-?$)|(^-?\d+([0-9])*$)|(^-?\d+([\\,])([0-9])*([\\.'])?([0-9]*)?$)|(^-?\d+([0-9])*([\\.'])([0-9]*)?$)/,
  },
  defaultStrikes: "31",
  defaultGreeksSources: [
    { label: "Market Implied Vol", value: 1 },
    { label: "Market Implied Vol w/ Fut Theo", value: 2 },
    { label: "QuikStrike Vol", value: 4 },
    { label: "QuikStrike Vol w/ Fut Theo", value: 8 },
  ],
  errorMessages: {
    "cmed/underlying": "Error retrieving underlying futures.",
    "cmed/optionsgrid/findOptions": "Error retrieving options.",
    "cmed/optionsgrid/expiry": "Error retreiving expiry for option.",
  },
  requestTimeout: 5000,
  onBehalfOf: {
    validCharacters: "^([A-Za-z0-9-_:@. ])*$",
    errorMessage:
      "Any value entered here must be between 2-20 characters, and can include - _ : @ or .",
  },
  subscribedFutures: {},
  midStrikeMaxLength: 31,
};
